<!-- 数据中心用户下拉选择框 -->
<template>
  <el-select :size="size"
             :value="value"
             :multiple="multiple"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :clearable="clearable"
             :disabled="disabled"
             @change="change($event)"
             class="width100"
  >
    <el-option v-for="item in userDictionary.items" :key="item[userDictionary.valueKey]"
               :value="item[userDictionary.valueKey]" :label="item[userDictionary.textKey]"
    ></el-option>
  </el-select>
</template>

<script>
  import AthubCloudApi from '@/api/athubCloud'

  import {Dictionary} from "@/util/common/dictionary";

  export default {
    name: "RoomUserSelect",
    props: [
      'size', 'value', 'multiple', 'collapseTags', 'filterable', 'clearable', 'disabled',
      'roomId'
    ],
    data() {
      return {
        users: [],
      };
    },
    computed: {
      userDictionary() {
        let items = this.users;
        return new Dictionary({items: items, valueKey: 'username', textKey: 'realname'});
      }
    },
    watch: {
      roomId: {
        immediate: true,
        deep: true,
        handler(value) {
          this.loadUsers(value);
        }
      },
    },
    methods: {
      loadUsers(roomId) {
        if (roomId != null && roomId.toString().trim() !== '') {
          AthubCloudApi.getUsersByRoomId(roomId).then((res) => {
            this.users = res;
          })
        } else {
          this.users = [];
        }
      },
      change(event) {
        this.$emit('input', event);
        this.$emit('change', [event, this.userDictionary.getText(event)]);
      }
    }
  }
</script>

<style scoped>

</style>
